import { Box, IconButton } from "@mui/material";
import React from "react";
import { CloseRounded } from "@mui/icons-material";
import {
  a11yProps,
  CustomTabPanel2,
  StyledTab,
  StyledTabs,
} from "../../Common/UI/TabPanel";
import {
  ActiveFavouriteIcon,
  ActiveTimeIcon,
  FavouriteIcon,
  MahaloAiStarIcon,
  TimeIcon,
} from "../../Common/assets/Icons";
import HistoryTab from "./HistoryTab";
import FavouritesTab from "./FavouritesTab";
import SearchBox from "./SearchTab/SearchBox";
import { AiDrawerStyles } from "./style";
import { useAppDispatch, useAppSelector } from "../../../Redux/hooks";
import { setAiTabType } from "../../../Redux/reducers/aiSearchSlice";

type Props = {
  showModal: boolean;
  closeModal: () => void;
  data: any;
};
const AiSearchModal = ({ showModal, closeModal, data }: Props) => {
  const dispatch = useAppDispatch();

  const aiTabType = useAppSelector((state) => state.aiSearch.aiTabType);

  const handleChange = (_: any, newValue: string) => {
    dispatch(setAiTabType(newValue));
  };
  return (
    <Box sx={AiDrawerStyles}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <StyledTabs value={aiTabType} onChange={handleChange}>
            <StyledTab
              sx={{ display: "flex", gap: "10px", minHeight: "48px" }}
              icon={<MahaloAiStarIcon />}
              iconPosition="start"
              label="AI Search"
              value="aiSearch"
              {...a11yProps(0)}
            />
            <StyledTab
              sx={{ display: "flex", gap: "10px", minHeight: "48px" }}
              icon={aiTabType === "history" ? <ActiveTimeIcon /> : <TimeIcon />}
              iconPosition="start"
              label="History"
              value="history"
              {...a11yProps(1)}
            />
            <StyledTab
              sx={{ display: "flex", gap: "10px", minHeight: "48px" }}
              icon={
                aiTabType === "favourite" ? (
                  <ActiveFavouriteIcon />
                ) : (
                  <FavouriteIcon />
                )
              }
              iconPosition="start"
              label="Favourite"
              value="favourite"
              {...a11yProps(2)}
            />
          </StyledTabs>
        </Box>

        <IconButton onClick={closeModal}>
          <CloseRounded sx={{ color: "text.secondary" }} />
        </IconButton>
      </Box>
      <Box sx={{ height: "calc(100% - 48px)" }}>
        <CustomTabPanel2 value={aiTabType} index={"aiSearch"}>
          <SearchBox />
        </CustomTabPanel2>
        <CustomTabPanel2 value={aiTabType} index={"history"}>
          <Box p={2.5}>
            <HistoryTab />
          </Box>
        </CustomTabPanel2>
        <CustomTabPanel2 value={aiTabType} index={"favourite"}>
          <Box p={2.5}>
            <FavouritesTab />
          </Box>
        </CustomTabPanel2>
      </Box>
    </Box>
  );
};

export default AiSearchModal;
